// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 357 ? "socketIoClient" : chunkId) + "." + {"357":"a3549df8","669":"26420544","888":"bc0bf035"}[chunkId] + ".chunk.js";
};